const block = document.querySelector('section.share-post');

if(block) {
    let copyBtn = block.querySelector('button');
    copyBtn.addEventListener('click', function() {
        let copyUrl = copyBtn.getAttribute('data-href');
        navigator.clipboard.writeText(copyUrl);
    });
}